import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useIntl, defineMessages } from 'react-intl';
import { FormFieldWrapper } from '@plone/volto/components/manage/Widgets';
import Api from '@plone/volto/helpers/Api/Api';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';

const messages = defineMessages({
  label: {
    id: 'Default page',
    defaultMessage: 'Item padrão da pasta',
  },
  none: {
    id: 'None (show folder)',
    defaultMessage: 'Nenhum (exibir a pasta)',
  },
  help: {
    id: 'Help default page',
    defaultMessage:
      'Ao acessar esta pasta, o item selecionado será exibido no lugar do conteúdo da pasta.',
  },
  loading: {
    id: 'Loading',
    defaultMessage: 'Carregando...',
  },
});

const DefaultPageWidget = (props) => {
  const { id, value, onChange } = props;
  const intl = useIntl();
  const pathname = useSelector((state) => state.router.location?.pathname);
  const [candidates, setCandidates] = useState([]);
  const [current, setCurrent] = useState(value || '');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!pathname) return;
    const baseUrl = getBaseUrl(pathname);
    const api = new Api();
    api
      .get(`${baseUrl}/@default-page`)
      .then((res) => {
        setCandidates(res.candidates || []);
        setCurrent(res.defaultPage || '');
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [pathname]);

  const handleChange = (event) => {
    const newValue = event.target.value || null;
    setCurrent(newValue);
    onChange(id, newValue);
  };

  return (
    <FormFieldWrapper
      {...props}
      id={id}
      title={intl.formatMessage(messages.label)}
    >
      <select
        id={`field-${id}`}
        className="ui dropdown"
        value={current || ''}
        onChange={handleChange}
        disabled={loading}
      >
        <option value="">
          {loading
            ? intl.formatMessage(messages.loading)
            : intl.formatMessage(messages.none)}
        </option>
        {candidates.map((item) => (
          <option key={item.id} value={item.id}>
            {item.title} - {item['@type']}
          </option>
        ))}
      </select>
      <p className="help" style={{ marginTop: '0.5em', opacity: 0.7 }}>
        {intl.formatMessage(messages.help)}
      </p>
    </FormFieldWrapper>
  );
};

DefaultPageWidget.defaultProps = {
  error: [],
};

export default DefaultPageWidget;
